import React from "react";
import porcelainImage from '../../images/ceramiques.JPG';
import CategoryPage from '../CategoryPage';

function PorcelainePage() {
    const details = [
        "Émile Gallé (France) – Maître de l’Art Nouveau, connu pour ses créations en pâte de verre et ses œuvres naturalistes.",
        "René Lalique (France) – Célèbre pour ses créations en cristal, alliant art déco et maîtrise du verre.",
        "Édouard Dammouse (France) – Créateur en pâte de verre, notamment pour la Manufacture des Gobelins.",
        "Lucien Lévy-Dhurmer (France) – Artiste de l’Art Nouveau, reconnu pour ses vases et objets en verre.",
        "Georges Fouquet (France) – Créateur d’objets en pâte de verre et bijouterie Art Nouveau.",
        "Sèvres (Manufacture de Sèvres) (France) – L’une des plus célèbres manufactures de porcelaine, fondée au XVIIIe siècle.",
        "Bernard Palissy (France) – Céramiste du XVIe siècle, reconnu pour ses créations en faïence émaillée.",
        "Pablo Picasso (Espagne) – Célèbre pour ses œuvres en céramique et ses créations artistiques modernes.",
        "Wedgwood (Angleterre) – Manufacturier de porcelaine fine, notamment connu pour ses créations néo-classiques.",
        "Charles Catteau (Belgique) – Artiste céramiste Art Déco, reconnu pour ses œuvres en céramique émaillée.",
    ];

    return (
        <CategoryPage
            title="Porcelaine et Verrerie"
            image={porcelainImage}
            description="En tant qu’antiquaire expert, je me spécialise dans l’achat de verrerie, pâte de verre, porcelaine, céramique et cristallerie anciennes. Chaque pièce de ces matériaux délicats a une histoire unique et une beauté à préserver. Que ce soit des vases en cristal, de la porcelaine ou des objets en verre, je vous propose une évaluation juste et respectueuse de leur valeur. Passionné par ces œuvres, je serai honoré de collaborer avec vous pour leur redonner vie. Contactez-moi pour discuter de vos trésors."
            details={details}
        />
    );
}

export default PorcelainePage;
